import axios from '@/api/axiosInstance';

export default async function updateTaskStudents({ taskId, studentIds }) {
  const response = await axios({
    method: 'put',
    url: `${process.env.NEXT_PUBLIC_API}/tasks/${taskId}/updateStudents`,
    data: studentIds,
  });
  return response.data;
}
